import {
  OBTENER_WSGSTATUS,
  OBTENER_WSGSTATUS_EXITO,
  OBTENER_WSGSTATUS_ERROR,
} from "../types";

// cada reducer tiene su propio state
const initialState = {
  wsgstatus: [],
  error: false,
  errorMessage: null,
  loading: false,
};

function wsgStatusReducer(state = initialState, action) {
  switch (action.type) {
    case OBTENER_WSGSTATUS:
      return {
        ...state,
        loading: action.payload,
      };
    case OBTENER_WSGSTATUS_EXITO:
      return {
        ...state,
        loading: false,
        error: null,
        wsgstatus: action.payload,
      };
    case OBTENER_WSGSTATUS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        errorMessage: action.payload.message,
      };
    default:
      return state;
  }
}

export default wsgStatusReducer;
